/* NO WASTE — carrusel de reels verticales.
   - Se reproducen en silencio solo cuando están a la vista (ahorra datos y batería).
   - Tocar el vídeo o el altavoz activa el sonido (y silencia los demás).
   - Flechas en ordenador; en móvil se desliza con el dedo. */
if (!customElements.get('nw-reels')) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
              if (isIntersecting && intersectionRatio >= 0.6 && !reduceMotion) {
                if (target.preload === 'none') target.preload = 'auto';
                target.play().catch(() => {});
              } else {
                target.pause();
              }
            });
          },
          { threshold: [0, 0.6] }
        )
      : null;

  // Empezar a cargar los reels un poco antes de que entren en pantalla (evita el destello negro)
  const preloader =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting && target.preload === 'none') { target.preload = 'auto'; target.load(); }
          }),
          { rootMargin: '200px 80% 200px 80%' }
        )
      : null;
  // La portada del vídeo tapa el reproductor hasta que el vídeo ya está pintando
  const markPlaying = (video) => {
    const frame = video.closest('.nw-reel__frame');
    if (!frame || frame.classList.contains('is-playing')) return;
    const reveal = () => frame.classList.add('is-playing');
    if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(reveal);
    else setTimeout(reveal, 120);
  };

  class NwReels extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nw-reels__track');
      this.buttons = this.querySelectorAll('.nw-reels__btn');
      this.videos = this.querySelectorAll('video');

      this.videos.forEach((video) => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        observer?.observe(video);
        preloader?.observe(video);
        video.addEventListener('playing', () => markPlaying(video));
        video.addEventListener('click', () => this.toggleSound(video));
      });

      this.querySelectorAll('.nw-reel__sound').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const video = btn.closest('.nw-reel').querySelector('video');
          if (video) this.toggleSound(video);
        });
      });

      this.buttons.forEach((btn) =>
        btn.addEventListener('click', () => {
          const item = this.track.firstElementChild;
          const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 300;
          this.track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: reduceMotion ? 'auto' : 'smooth' });
        })
      );

      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.videos?.forEach((v) => observer?.unobserve(v));
      this.resizeObserver?.disconnect();
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const scrollable = scrollWidth > clientWidth + 4;
      this.classList.toggle('is-scrollable', scrollable);
      if (!this.buttons.length) return;
      this.buttons[0].disabled = scrollLeft <= 4;
      this.buttons[1].disabled = scrollLeft + clientWidth >= scrollWidth - 4;
    }

    toggleSound(video) {
      const turnOn = video.muted;
      document.querySelectorAll('nw-reels video').forEach((v) => {
        v.muted = true;
        v.closest('.nw-reel')?.querySelector('.nw-reel__sound')?.setAttribute('aria-pressed', 'false');
      });
      if (turnOn) {
        video.muted = false;
        video.play().catch(() => {});
      }
      const btn = video.closest('.nw-reel')?.querySelector('.nw-reel__sound');
      btn?.setAttribute('aria-pressed', String(turnOn));
      btn?.setAttribute('aria-label', turnOn ? 'Silenciar' : 'Activar sonido');
    }
  }

  customElements.define('nw-reels', NwReels);
}

/* Vídeos sueltos (galería, cabeceras): reproducir en silencio solo cuando se ven */
(() => {
  const vids = document.querySelectorAll('video[data-nw-autoplay]');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
    if (isIntersecting && !reduce) { target.muted = true; if (target.preload === 'none') target.preload = 'auto'; target.play().catch(() => {}); }
    else target.pause();
  }), { threshold: 0.4 });
  vids.forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
})();
